(function() {
  const LOCAL_STORAGE_NAME = 'p4_recent_view_2';
  const MAX_LIST_COUNT = 9;
  const CONTAINER = document.querySelector('#js-recent-view');
  const CONTAINER_LIST = CONTAINER.querySelector('#js-recent-view--list');
  const OPTIONAL_WRAPPER = document.querySelector('#js-recent-view--wrapper');
  const curProductID = window.APP.productID;
  let recentView = JSON.parse(localStorage.getItem(LOCAL_STORAGE_NAME)) ?? [];

  showRecentView();
  updateLocalStorage();
  track();

  /**
   * Add and reveal the recent view list.
   */
  function showRecentView() {
    // Skip if the list is empty or if the only item is the current product.
    if (recentView.length === 0 ||
       (recentView.length === 1 && recentView[0].id === curProductID)) return;

    const template = window.tmpl('jsRecentViewTemplate');
    const html = recentView.reduce((html, product) => {
        // Skip current product.
        return (product.id === curProductID) ? html : html + template(product);
      }, '');

    CONTAINER.hidden = false;
    CONTAINER_LIST.innerHTML = html;
    if (OPTIONAL_WRAPPER) OPTIONAL_WRAPPER.hidden = false;
  }

  /**
   * Add current product data to the recent view list. If already on the list,
   * move it to the fore.
   *
   * @async
   */
  async function updateLocalStorage() {
    // Skip if not on a product page.
    if (!curProductID) return;

    const curProductIndex = recentView.findIndex((p) => p.id === curProductID);

    if (curProductIndex === -1) {
      try {
        // Add current product to the list.
        recentView.unshift(await getProductData(curProductID));
      } catch(err) {
        console.error(err);
        return;
      }
    } else {
      // Move current product to the front of the list.
      recentView.unshift(recentView.splice(curProductIndex, 1)[0]);
    }

    // Trim list to size.
    //
    // An extra item beyond `MAX_LIST_COUNT` is kept for when the user returns
    // to a listed item, whereupon the previously visited item is merely skipped
    // and, without the extra, the total count will be one short.
    recentView.splice(MAX_LIST_COUNT + 1);
    localStorage.setItem(LOCAL_STORAGE_NAME, JSON.stringify(recentView));
  }

  /**
   * Get product data via Storefront API.
   *
   * @async
   * @param {number} productID
   * @returns {object}
   */
  async function getProductData(productID) {
    const data = await window.APP.queryStorefront(`
      {
        product(id: "gid://shopify/Product/${productID}") {
          title
          productType
          featuredImage {
            url
          }
          media(first: 1) {
            nodes {
              previewImage {
                url
              }
            }
          }
        }
      }
    `);

    if (!data.product) throw `Product not found: ${productID}`;

    return {
      id: productID,
      link: window.location.pathname,
      img: data.product.productType === 'Display' ?
        data.product.media.nodes[0].previewImage.url :
        data.product.featuredImage.url,
      title: data.product.title,
    };
  }

  function track() {
    if (typeof gtag === 'undefined') return;

    const eventParams = {
      page_type: document.body.dataset.template,
    };

    // Track visibility.
    window.APP.trackVisibilityOnce(CONTAINER, 'cross_sell_recent_product_view', eventParams);

    // Track clicks.
    CONTAINER_LIST.querySelectorAll('a').forEach(link => {
      window.APP.trackClick(link, 'cross_sell_recent_product_click', eventParams);
    });
  }
})();
